// extracted by mini-css-extract-plugin
export default {"container":"Oken7X","button":"mGgOrq","icon":"hT2lb9","tooltipInner":"jBZRMz","tooltipText":"XK5a7n","tooltip":"bScf8e"};